"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.records.title': 'Twoje Zapisy Wdrożenia',
    'onboarding.records.empty.title': 'Brak Zapisów Wdrożenia',
    'onboarding.records.empty.description': 'Rozpocznij pierwszy proces wdrożenia, aby zobaczyć tutaj zapisy.',
};
